<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formService">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" (onClick)="goToBack($event)" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <!-- ADJUNTAR ARCHIVOS -->
              <app-custom-button [title]="'Adjuntar archivos'" [icon]="'pi pi-paperclip'" [severity]="'contrast'"
                (onClick)="openAttachFile()"></app-custom-button>
              <app-custom-modal #attachFileService [header]="'Adjuntar archivos'" [children]="componentAttachFiles"
                [closable]="true" [width]="'40vw'" [inputs$]="inputsForAttachFiles$" [output$]="outputForAttachFiles$"
                hidden>
              </app-custom-modal>
              <!-- IMPRIMIR -->
              <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
                (onClick)="printPage()"></app-custom-button>
              <!-- ELIMINAR -->
              <app-custom-button [title]="'Eliminar'" [severity]="'contrast'" [icon]="'pi pi-trash'"
                (onClick)="deleteService()"></app-custom-button>
              <!-- NUEVO -->
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                (onClick)="createNewService()" [severity]="'success'" [width]="'5rem'"
                [variant]="undefined"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
              <app-custom-audit-info [userNameCreate]="serviceContract.userNameCreate"
                [createDate]="serviceContract.createDate" [userNameUpdate]="serviceContract.userNameUpdate"
                [updateDate]="serviceContract.updateDate"
                [reserveSpace]="true"></app-custom-audit-info>
            </div>
          </div>
          <div class="row d-flex justify-content-between">
            <div class="col-lg-8 col-md-12 col-sm-12 col-12 pe-lg-5 pe-md-2">
              <div class="row">
                <div class="col-lg-4 col-md-5 col-sm-6 col-12">
                  <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranch"
                    [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event, false); changeValues()">
                  </app-custom-select>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                  <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
                    [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                  <app-custom-input-number formControlName="alterNumber" [labelText]="'Nro.Alterno'"
                    [recovery]="false"></app-custom-input-number>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-3 col-6">
                  <app-custom-datepicker formControlName="dateService" [labelText]="'Fecha'" [required]="true"
                    (onChangeDate)="changeValues()"></app-custom-datepicker>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-4 col-12">
                  <app-custom-select formControlName="isTypeCutoffMovement" [labelText]="'Tipo Corte'"
                    [list]="listTypeCutoffMovement" [required]="true"
                    (onChangeSelect)="changeValues()"></app-custom-select>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-8 col-12">
                  <app-custom-autocomplete formControlName="clientId" [labelText]="'Cliente'" [list]="listClients"
                    [required]="true" [class]="clientStateId !== clientStateActive ? 'state-inactive' : ''"
                    (onChangeSelect)="getClient($event)">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-8 col-12">
                  <app-custom-autocomplete formControlName="costCenterId" [labelText]="'C.Costos'"
                    [list]="filteredCostCenters" [required]="true" (onChangeSelect)="getCostCenter($event, false);"
                    [class]="getClassCostCenter()">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-12 d-flex align-items-end mt-2 gap-2">
                  <app-custom-checkbox formControlName="swInvoiceSeparately" [labelText]="'Fra.Aparte'">
                  </app-custom-checkbox>
                  <app-custom-checkbox formControlName="swOrder" [labelText]="'Req.Pedido'"
                    (onChangeCheckBox)="changeSwOrder($event)">
                  </app-custom-checkbox>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-12 col-sm-12 col-12 ps-md-2 pt-lg-0 pt-sm-2">
              <div class="row">
                <div class="col-lg-3 col-md-2 col-sm-4 col-4">
                  <app-custom-inputgroup [inputValue]="consecutiveOrder" [labelText]="'Pedido'"
                    [iconButton]="'pi pi-external-link'" [titleButton]="'Selección Pedidos'"
                    (onClick)="openOrderModal()">
                  </app-custom-inputgroup>
                </div>
                <div class="col-lg-3 col-md-2 col-sm-4 col-4">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState"
                    [value]="serviceStateString"></app-custom-tag>
                </div>
                <div class="col-lg-4 col-md-2 col-sm-3 col-4 d-flex align-items-end gap-1 mt-1 mb-1">
                  <app-custom-button [icon]="iconStateService" [title]="titleStateService" [severity]="'primary'"
                    (onClick)="changeStateService()"></app-custom-button>
                  <app-custom-button [title]="'Anular Servicio'" [icon]="'pi pi-ban'" [severity]="'warn'"
                    (onClick)="annulService()"></app-custom-button>
                  <app-custom-checkbox formControlName="swBlock" class="mt-1" [labelText]="'Bloq.'"
                    (onChangeCheckBox)="blockService($event)"></app-custom-checkbox>
                </div>
                <div
                  class="col-lg-2 col-md-1 col-sm-1 col-2 d-flex justify-content-lg-end align-items-end mt-2 my-lg-0">
                  <div class="d-flex flex-md-row flex-lg-column justify-content-end align-items-end">
                    <app-custom-chip [label]="'Corte: ' + invoicingCutoffCode" />
                  </div>
                </div>
                <div class="col-lg-12 col-md-5 col-sm-12 col-10">
                  <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                    [rows]="1" [maxLength]="250"></app-custom-textarea>
                </div>
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 ms-auto d-flex justify-content-end align-items-end mt-2">
                  <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
                    [variant]="undefined" (onClick)="send()">
                  </app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-service-detail [serviceModel]="serviceContract" [disabledDetail]="disabledDetail" [formService]="formService"
      [isCreatingServiceFromOrder]="isCreatingServiceFromOrder" [quantityDetails]="quantityDetails"
      [permissionUpdatable]="permissionUpdatable" [permissionsUser]="permissionsUser"
      [defaultStoreIdForBranch]="defaultStoreIdForBranch" [userAuthenticated]="userAuthenticated"
      [swfacturacionEspecial]="swfacturacionEspecial" [swServiceRequiresOrder]="swServiceRequiresOrder"
      (emitQuantityDetails)="quantityDetails = $event" (serviceContract)="onServiceUpdate($event)">
    </app-service-detail>
  </div>
</section>

<app-print-service id="print-service" [companyId]="companyId" [reloadPrint]="reloadPrint"
  [servicePrintModel]="servicePrintModel" [focusText]="false" [editFormat]="false"
  (finishLoadingPrint)="finishLoading($event)">
</app-print-service>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>